import React, { useState } from "react";
import {
    Box,
    IconButton,
    Drawer,
    List,
    ListItemButton,
    ListItemText,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
} from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import MenuIcon from "@mui/icons-material/Menu";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function NavBar() {
    const [anchorElAbout, setAnchorElAbout] = useState(null);
    const [anchorElServices, setAnchorElServices] = useState(null);
    const [anchorElIndustries, setAnchorElIndustries] = useState(null);
    const [anchorElSolutions, setAnchorElSolutions] = useState(null);
    const [anchorElProducts, setAnchorElProducts] = useState(null);
    const [anchorElUser, setAnchorElUser] = useState(null);
    const [anchorElNav, setAnchorElNav] = useState(null);

    const [mobileSubMenu, setMobileSubMenu] = useState(null);

    const [anchorElMobility, setAnchorElMobility] = useState(null);
    const [anchorElMobileApps, setAnchorElMobileApps] = useState(null);
    const [anchorElWebApp, setAnchorElWebApp] = useState(null);
    const [anchorElTesting, setAnchorElTesting] = useState(null);
    const [activeSubMenu, setActiveSubMenu] = useState(null);
    const [drawerOpen, setDrawerOpen] = useState(false);


    const handleMobileMenuOpen = (menu) => {
        setMobileSubMenu(menu);
    };

    const handleMobileMenuClose = () => {
        setMobileSubMenu(null);
    };


    const handleOpen = (setter) => (event) => setter(event.currentTarget);
    const handleClose = (setter) => () => setter(null);

    return (
        <AppBar position="fixed" sx={{ backgroundColor: "#fff" }}> {/* #030366 */}
            <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                    <a href="/">
                        <img
                            src="/images/vensyxlogo.png"
                            alt="Logo"
                            style={{ width: 40, height: 40, marginRight: 10 }}
                        />
                    </a>
                    <Typography variant="h6" sx={{ color: "#030366", fontWeight: 600 }}>
                        VENSYX Data Solutions
                    </Typography>
                </Box>

                {/* Desktop Menu */}
                <Box sx={{ display: { xs: "none", md: "flex" }, gap: 4 }}>
                    <Button href="/" sx={{ color: "#030366" }}>
                        Home
                    </Button>

                    {/* Corporate dropdown */}
                    <Button
                        sx={{
                            color: "#030366",
                            "&:hover": {
                                backgroundColor: "#0056b3", // blue background
                                color: "black"
                            }
                        }}
                        onMouseEnter={(e) => setAnchorElAbout(e.currentTarget)} // open on hover
                    >
                        Corporate
                    </Button>

                    <Menu
                        anchorEl={anchorElAbout}
                        open={Boolean(anchorElAbout)}
                        onClose={() => setAnchorElAbout(null)}
                        MenuListProps={{
                            onMouseLeave: () => setAnchorElAbout(null),
                        }}
                    >
                        <MenuItem onClick={() => setAnchorElAbout(null)} href="/aboutus" component="a">About Us</MenuItem>
                        <MenuItem onClick={() => setAnchorElAbout(null)} href="/vision-mission" component="a">Vision & Mission</MenuItem>
                        <MenuItem onClick={() => setAnchorElAbout(null)} href="/core-value" component="a">Core Value</MenuItem>
                        <MenuItem onClick={() => setAnchorElAbout(null)} href="/social-responsibility" component="a">Social Responsibility</MenuItem>
                        <MenuItem onClick={() => setAnchorElAbout(null)} href="/location" component="a">Location</MenuItem>
                        <MenuItem onClick={() => setAnchorElAbout(null)} href="/teams" component="a">Team</MenuItem>
                    </Menu>


                    {/* Solutions dropdown */}
                    <Button
                        sx={{
                            color: "#030366",
                            "&:hover": {
                                backgroundColor: "#0056b3", // blue background on hover
                                color: "black"
                            }
                        }}
                        onMouseEnter={(e) => setAnchorElSolutions(e.currentTarget)} // open on hover
                    >
                        Solutions
                    </Button>

                    <Menu
                        anchorEl={anchorElSolutions}
                        open={Boolean(anchorElSolutions)}
                        onClose={() => setAnchorElSolutions(null)}
                        MenuListProps={{
                            onMouseLeave: () => setAnchorElSolutions(null), // close only when leaving menu
                        }}
                    >
                        <MenuItem onClick={() => setAnchorElSolutions(null)} href="/big-data-and-advanced-analytics" component="a">
                            Big Data & Advanced Analytics
                        </MenuItem>
                        <MenuItem onClick={() => setAnchorElSolutions(null)} href="/business-intelligence-solutions" component="a">
                            Business Intelligence Solutions
                        </MenuItem>
                        <MenuItem onClick={() => setAnchorElSolutions(null)} href="/data-management" component="a">
                            Data Management
                        </MenuItem>
                        <MenuItem onClick={() => setAnchorElSolutions(null)} href="/enterprise-data-warehouse" component="a">
                            Enterprise Data Warehouse
                        </MenuItem>
                        <MenuItem onClick={() => setAnchorElSolutions(null)} href="/application-middleware-management" component="a">
                            Application Middleware Management
                        </MenuItem>
                    </Menu>


                    {/* Products dropdown */}
                    <Button
                        sx={{
                            color: "#030366",
                            "&:hover": {
                                backgroundColor: "#0056b3", // blue background on hover
                                color: "black"
                            }
                        }}
                        onMouseEnter={(e) => setAnchorElProducts(e.currentTarget)} // open on hover
                    >
                        Products
                    </Button>

                    <Menu
                        anchorEl={anchorElProducts}
                        open={Boolean(anchorElProducts)}
                        onClose={() => setAnchorElProducts(null)}
                        MenuListProps={{
                            onMouseLeave: () => setAnchorElProducts(null), // close when leaving menu
                        }}
                    >
                        <MenuItem onClick={() => setAnchorElProducts(null)} href="/log-mode" component="a">
                            Log-Mode
                        </MenuItem>
                    </Menu>


                    {/* Services dropdown */}
                    <Button
                        sx={{
                            color: "#030366",
                            "&:hover": { backgroundColor: "#0056b3", color: "black" }
                        }}
                        onMouseEnter={(e) => setAnchorElServices(e.currentTarget)}
                    >
                        Services
                    </Button>

                    <Menu
                        anchorEl={anchorElServices}
                        open={Boolean(anchorElServices)}
                        onClose={() => {
                            setAnchorElServices(null)
                            setActiveSubMenu(null)
                        }}
                        disableAutoFocusItem
                    >
                        {/* Enterprise Mobility Services */}
                        <MenuItem
                            onMouseEnter={(e) => {
                                setAnchorElMobility(e.currentTarget)
                                setActiveSubMenu("mobility")
                            }}
                            sx={{
                                backgroundColor: activeSubMenu === "mobility" ? "#e0f2ff" : "transparent",
                                fontWeight: activeSubMenu === "mobility" ? 600 : 400,
                                cursor: "pointer"
                            }}
                        >
                            Enterprise Mobility Services
                        </MenuItem>
                        <Menu
                            anchorEl={anchorElMobility}
                            open={Boolean(anchorElMobility)}
                            onClose={() => setAnchorElMobility(null)}
                            anchorOrigin={{ vertical: "top", horizontal: "left" }}
                            transformOrigin={{ vertical: "top", horizontal: "right" }}
                            disableAutoFocusItem
                        >
                            <MenuItem onClick={() => setAnchorElMobility(null)} href="/enterprise-mobility-service/business-process" component="a">Business Process Mobilization</MenuItem>
                            <MenuItem onClick={() => setAnchorElMobility(null)} href="/enterprise-mobility-service/B2B-mobile-apps" component="a">B2B Mobile Apps Development</MenuItem>
                            <MenuItem onClick={() => setAnchorElMobility(null)} href="/enterprise-mobility-service/enterprise-android-app" component="a">Enterprise Android App Development</MenuItem>
                            <MenuItem onClick={() => setAnchorElMobility(null)} href="/enterprise-mobility-service/enterprise-app" component="a">Enterprise App Distribution</MenuItem>
                            <MenuItem onClick={() => setAnchorElMobility(null)} href="/enterprise-mobility-service/enterprise-ios-app" component="a">Enterprise IOS App Development</MenuItem>
                            <MenuItem onClick={() => setAnchorElMobility(null)} href="/enterprise-mobility-service/mobile-business" component="a">Mobile Business Intelligence</MenuItem>
                        </Menu>

                        {/* Mobile Apps Development */}
                        <MenuItem
                            onMouseEnter={(e) => {
                                setAnchorElMobileApps(e.currentTarget)
                                setActiveSubMenu("mobileApps");
                            }}
                            sx={{
                                backgroundColor: activeSubMenu === "mobileApps" ? "#e0f2ff" : "transparent",
                                fontWeight: activeSubMenu === "mobileApps" ? 600 : 400
                            }}
                        >
                            Mobile Apps Development
                        </MenuItem>
                        <Menu
                            anchorEl={anchorElMobileApps}
                            open={Boolean(anchorElMobileApps)}
                            onClose={() => setAnchorElMobileApps(null)}
                            anchorOrigin={{ vertical: "top", horizontal: "left" }}
                            transformOrigin={{ vertical: "top", horizontal: "right" }}
                            disableAutoFocusItem
                        >
                            <MenuItem onClick={() => setAnchorElMobileApps(null)} href="/mobile-apps-development/android-app-development" component="a">Android App Development</MenuItem>
                            <MenuItem onClick={() => setAnchorElMobileApps(null)} href="/mobile-apps-development/windows8-app-development" component="a">Windows8 App Development</MenuItem>
                            <MenuItem onClick={() => setAnchorElMobileApps(null)} href="/mobile-apps-development/blackberry-app-development" component="a">Blackberry App Development</MenuItem>
                            <MenuItem onClick={() => setAnchorElMobileApps(null)} href="/mobile-apps-development/Iphone-app-development" component="a">Iphone App Development</MenuItem>
                        </Menu>

                        {/* Web Application Development */}
                        <MenuItem
                            onMouseEnter={(e) => {
                                setAnchorElWebApp(e.currentTarget)
                                setActiveSubMenu("webApp");
                            }}
                            sx={{
                                backgroundColor: activeSubMenu === "webApp" ? "#e0f2ff" : "transparent",
                                fontWeight: activeSubMenu === "webApp" ? 600 : 400
                            }}
                        >
                            Web Application Development
                        </MenuItem>
                        <Menu
                            anchorEl={anchorElWebApp}
                            open={Boolean(anchorElWebApp)}
                            onClose={() => setAnchorElWebApp(null)}
                            anchorOrigin={{ vertical: "top", horizontal: "left" }}
                            transformOrigin={{ vertical: "top", horizontal: "right" }}
                            disableAutoFocusItem
                        >
                            <MenuItem onClick={() => setAnchorElWebApp(null)} href="/web-application-development/CRM-application" component="a">CRM Application Development</MenuItem>
                            <MenuItem onClick={() => setAnchorElWebApp(null)} href="/web-application-development/inventory-management" component="a">Inventory Management</MenuItem>
                            <MenuItem onClick={() => setAnchorElWebApp(null)} href="/web-application-development/content-management" component="a">Content Management System</MenuItem>
                            <MenuItem onClick={() => setAnchorElWebApp(null)} href="/web-application-development/custom-web-app" component="a">Custom Webapp Development</MenuItem>
                            <MenuItem onClick={() => setAnchorElWebApp(null)} href="/web-application-development/open-source" component="a">Open-source Development</MenuItem>
                        </Menu>

                        {/* Testing And QA Services */}
                        <MenuItem
                            onMouseEnter={(e) => {
                                setAnchorElTesting(e.currentTarget)
                                setActiveSubMenu("testing");
                            }}
                            sx={{
                                backgroundColor: activeSubMenu === "testing" ? "#e0f2ff" : "transparent",
                                fontWeight: activeSubMenu === "testing" ? 600 : 400
                            }}
                        >
                            Testing And QA Services
                        </MenuItem>
                        <Menu
                            anchorEl={anchorElTesting}
                            open={Boolean(anchorElTesting)}
                            onClose={() => setAnchorElTesting(null)}
                            anchorOrigin={{ vertical: "top", horizontal: "left" }}
                            transformOrigin={{ vertical: "top", horizontal: "right" }}
                            disableAutoFocusItem
                        >
                            <MenuItem onClick={() => setAnchorElTesting(null)} href="/testing-QA-services/automated-testing" component="a">Automated Testing</MenuItem>
                            <MenuItem onClick={() => setAnchorElTesting(null)} href="/testing-QA-services/selenium" component="a">Selenium</MenuItem>
                            <MenuItem onClick={() => setAnchorElTesting(null)} href="/testing-QA-services/qtp" component="a">QTP</MenuItem>
                            <MenuItem onClick={() => setAnchorElTesting(null)} href="/testing-QA-services/manual-testing" component="a">Manual Testing</MenuItem>
                            <MenuItem onClick={() => setAnchorElTesting(null)} href="/testing-QA-services/test-complete" component="a">Test Complete</MenuItem>
                        </Menu>

                        {/* Example of single link without submenu */}
                        <MenuItem
                            onMouseEnter={(e) => {
                                setActiveSubMenu("businessIntelligence");
                            }}
                            onClick={() => setAnchorElServices(null)} href="/business-intelligence-service" component="a"
                            sx={{
                                backgroundColor: activeSubMenu === "businessIntelligence" ? "#e0f2ff" : "transparent",
                                fontWeight: activeSubMenu === "businessIntelligence" ? 600 : 400
                            }}
                        >
                            Business Intelligence Services
                        </MenuItem>
                    </Menu>


                    {/* Industries dropdown */}
                    <Button
                        sx={{
                            color: "#030366",
                            "&:hover": {
                                backgroundColor: "#0056b3", // blue background on hover
                                color: "black"
                            }
                        }}
                        onMouseEnter={(e) => setAnchorElIndustries(e.currentTarget)} // open on hover
                    >
                        Industries
                    </Button>

                    <Menu
                        anchorEl={anchorElIndustries}
                        open={Boolean(anchorElIndustries)}
                        onClose={() => setAnchorElIndustries(null)}
                        MenuListProps={{
                            onMouseLeave: () => setAnchorElIndustries(null), // close only when leaving menu
                        }}
                    >
                        <MenuItem onClick={() => setAnchorElIndustries(null)} href="/telecommunications" component="a">
                            Telecommunication
                        </MenuItem>
                        <MenuItem onClick={() => setAnchorElIndustries(null)} href="/retail" component="a">
                            Retail
                        </MenuItem>
                        <MenuItem onClick={() => setAnchorElIndustries(null)} href="/financial-services" component="a">
                            Financial Services
                        </MenuItem>
                        <MenuItem onClick={() => setAnchorElIndustries(null)} href="/manufacturing" component="a">
                            Manufacturing
                        </MenuItem>
                        <MenuItem onClick={() => setAnchorElIndustries(null)} href="/utilities" component="a">
                            Utilities
                        </MenuItem>
                        <MenuItem onClick={() => setAnchorElIndustries(null)} href="/government" component="a">
                            Government
                        </MenuItem>
                    </Menu>
                </Box>


                {/* Mobile Menu */}
                <Box sx={{ display: { xs: "flex", md: "none" } }}>
                    <IconButton
                        size="large"
                        color="#030366"
                        onClick={() => setDrawerOpen(true)}
                    >
                        <MenuIcon />
                    </IconButton>

                    <Drawer
                        anchor="right"
                        open={drawerOpen}
                        onClose={() => setDrawerOpen(false)}
                        PaperProps={{
                            sx: { width: "80%", bgcolor: "#fff", color: "#000", p: 1 },
                        }}
                    >
                        <List>
                            {/* Home */}
                            <ListItemButton component="a" href="/">Home</ListItemButton>

                            {/* Corporate */}
                            <Accordion>
                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                    <Typography>Corporate</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <List disablePadding>
                                        <ListItemButton component="a" href="/aboutus">About Us</ListItemButton>
                                        <ListItemButton component="a" href="/vision-mission">Vision & Mission</ListItemButton>
                                        <ListItemButton component="a" href="/core-value">Core Value</ListItemButton>
                                        <ListItemButton component="a" href="/social-responsibility">Social Responsibility</ListItemButton>
                                        <ListItemButton component="a" href="/location">Location</ListItemButton>
                                        <ListItemButton component="a" href="/teams">Team</ListItemButton>
                                    </List>
                                </AccordionDetails>
                            </Accordion>

                            {/* Solutions */}
                            <Accordion>
                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                    <Typography>Solutions</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <List disablePadding>
                                        <ListItemButton href="/big-data-and-advanced-analytics">Big Data & Advanced Analytics</ListItemButton>
                                        <ListItemButton href="/business-intelligence-solutions">Business Intelligence Solutions</ListItemButton>
                                        <ListItemButton href="/data-management">Data Management</ListItemButton>
                                        <ListItemButton href="/enterprise-data-warehouse">Enterprise Data Warehouse</ListItemButton>
                                        <ListItemButton href="/application-middleware-management">Application Middleware Management</ListItemButton>
                                    </List>
                                </AccordionDetails>
                            </Accordion>

                            {/* Products */}
                            <Accordion>
                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                    <Typography>Products</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <List disablePadding>
                                        <ListItemButton href="/log-mode">Log-Mode</ListItemButton>
                                    </List>
                                </AccordionDetails>
                            </Accordion>

                            {/* Services */}
                            <Accordion>
                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                    <Typography>Services</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Accordion>
                                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                            <Typography>Enterprise Mobility Services</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <List disablePadding>
                                                <ListItemButton href="/enterprise-mobility-service/business-process">Business Process Mobilization</ListItemButton>
                                                <ListItemButton href="/enterprise-mobility-service/B2B-mobile-apps">B2B Mobile Apps Development</ListItemButton>
                                                <ListItemButton href="/enterprise-mobility-service/enterprise-android-app">Enterprise Android App Development</ListItemButton>
                                                <ListItemButton href="/enterprise-mobility-service/enterprise-app">Enterprise App Distribution</ListItemButton>
                                                <ListItemButton href="/enterprise-mobility-service/enterprise-ios-app">Enterprise IOS App Development</ListItemButton>
                                                <ListItemButton href="/enterprise-mobility-service/mobile-business">Mobile Business Intelligence</ListItemButton>
                                            </List>
                                        </AccordionDetails>
                                    </Accordion>

                                    <Accordion>
                                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                            <Typography>Mobile Apps Development</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <List disablePadding>
                                                <ListItemButton href="/mobile-apps-development/android-app-development">Android App Development</ListItemButton>
                                                <ListItemButton href="/mobile-apps-development/windows8-app-development">Windows8 App Development</ListItemButton>
                                                <ListItemButton href="/mobile-apps-development/blackberry-app-development">Blackberry App Development</ListItemButton>
                                                <ListItemButton href="/mobile-apps-development/Iphone-app-development">Iphone App Development</ListItemButton>
                                            </List>
                                        </AccordionDetails>
                                    </Accordion>

                                    <Accordion>
                                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                            <Typography>Web Application Development</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <List disablePadding>
                                                <ListItemButton href="/web-application-development/CRM-application">CRM Application Development</ListItemButton>
                                                <ListItemButton href="/web-application-development/inventory-management">Inventory Management</ListItemButton>
                                                <ListItemButton href="/web-application-development/content-management">Content Management System</ListItemButton>
                                                <ListItemButton href="/web-application-development/custom-web-app">Custom Webapp Development</ListItemButton>
                                                <ListItemButton href="/web-application-development/open-source">Open-source Development</ListItemButton>
                                            </List>
                                        </AccordionDetails>
                                    </Accordion>

                                    <Accordion>
                                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                            <Typography>Testing And QA Services</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <List disablePadding>
                                                <ListItemButton href="/testing-QA-services/automated-testing">Automated Testing</ListItemButton>
                                                <ListItemButton href="/testing-QA-services/selenium">Selenium</ListItemButton>
                                                <ListItemButton href="/testing-QA-services/qtp">QTP</ListItemButton>
                                                <ListItemButton href="/testing-QA-services/manual-testing">Manual Testing</ListItemButton>
                                                <ListItemButton href="/testing-QA-services/test-complete">Test Complete</ListItemButton>
                                            </List>
                                        </AccordionDetails>
                                    </Accordion>

                                    <ListItemButton href="/business-intelligence-service">
                                        Business Intelligence Services
                                    </ListItemButton>
                                </AccordionDetails>
                            </Accordion>

                            {/* Industries */}
                            <Accordion>
                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                    <Typography>Industries</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <List disablePadding>
                                        <ListItemButton href="/telecommunications">Telecommunication</ListItemButton>
                                        <ListItemButton href="/retail">Retail</ListItemButton>
                                        <ListItemButton href="/financial-services">Financial Services</ListItemButton>
                                        <ListItemButton href="/manufacturing">Manufacturing</ListItemButton>
                                        <ListItemButton href="/utilities">Utilities</ListItemButton>
                                        <ListItemButton href="/government">Government</ListItemButton>
                                    </List>
                                </AccordionDetails>
                            </Accordion>
                        </List>
                    </Drawer>
                </Box>

            </Toolbar>
        </AppBar>
    );
}
